var map = {
	"./Novecentosanswide-Bold-webfont.woff": "./src/assets/fonts/Novecentosanswide-Bold-webfont.woff",
	"./Novecentosanswide-Bold-webfont.woff2": "./src/assets/fonts/Novecentosanswide-Bold-webfont.woff2",
	"./Novecentosanswide-Normal-webfont.woff": "./src/assets/fonts/Novecentosanswide-Normal-webfont.woff",
	"./Novecentosanswide-Normal-webfont.woff2": "./src/assets/fonts/Novecentosanswide-Normal-webfont.woff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/fonts sync recursive \\.(woff|woff2)$";